import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Nav from '../Nav';
import './style.css';
export default class NotFound extends Component {
  render() {
    return (
      <div>
        <Nav />
        <div className="container-fluid fe-main-wrapper">
          <div className="fe-main-content">
            <Grid fluid>
              <Row>
                <Col xs={12}>
                  <h1 className="page-header">Not Found</h1>
                </Col>
              </Row>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/NotFound/index.js